import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RequestPanelFull from './RequestPanelFull';
import RequestPanelNarrow from './RequestPanelNarrow';

const RequestPanel = ({ configuration, onChange }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RequestPanelFull, narrow: RequestPanelNarrow }}
    onChange={onChange}
    width={800}
  />
);

export default RequestPanel;
